import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 22,
  medium: 15,
  small: 15,
  xSmall: 13
};
const ExternalLinkIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "xSmall":
      case "small":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            fill: "none",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M17.5 2.4978V9.00231H16.5V4.20941L8.5 12.2094L7.79289 11.5023L15.7824 3.51282L11.0045 3.55614L10.9955 2.55618L17.5 2.4978Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M2.5 17.5023V2.49807L6.67089 2.55019L6.66244 3.55016L3.5 3.50531V16.5023H16.5V13.3356H17.5V17.5023H2.5Z",
              fill: "currentColor"
            }
          )
        );
      case "medium":
      case "large":
      default:
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M22.5 7.49548V14H21.5V9.20709L13.5 17.2071L12.7929 16.5L20.7824 8.5105L16.0045 8.55382L15.9955 7.55386L22.5 7.49548Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ React.createElement("path", { d: "M7.5 22.5V7.49575L11.6709 7.54788L11.6624 8.54784L8.5 8.50299V21.5H21.5V18.3333H22.5V22.5H7.5Z", fill: "currentColor" })
        );
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderIcon());
};
ExternalLinkIcon.iconName = "ExternalLinkIcon";

export { ExternalLinkIcon };
